<myqq-modal-header> </myqq-modal-header>
<div class="fld-col ai-ctr pwx-3 verbiage-padding">
  <p class="fw-u3 fs-u2 ta-c">
    Thank you for signing up.<br />
    Have you already purchased a Quick Quack wash membership or single wash?
  </p>

  <div class="fld-row flg-5">
    <a
      mat-stroked-button
      aria-label="Member"
      class="btn member-btn"
      [class]="processing ? 'disable-btn' : ''"
      color="primary"
      data-cy="member-btn"
      (click)="selectedMember()"
      (keyup.enter)="selectedMember()"
      (keydown.enter)="$event.preventDefault()"
    >
      {{ processing ? "" : "Yes" }}

      <mat-spinner diameter="24" *ngIf="processing"></mat-spinner>
    </a>
    <a
      mat-flat-button
      aria-label="Non-Member"
      class="btn non-member-btn"
      [class]="processing ? 'disable-btn' : ''"
      color="primary"
      data-cy="non-member-btn"
      (click)="selectedNonMember()"
      (keyup.enter)="selectedNonMember()"
      (keydown.enter)="$event.preventDefault()"
    >
      {{ processing ? "" : "No" }}
      <mat-spinner diameter="24" *ngIf="processing"></mat-spinner>
    </a>
  </div>
</div>
